module.exports = __webpack_public_path__ + "static/media/barbara4.c6d46fcf.mp3";